import * as React from 'react'

import { QueryStatus, type Response } from './useQuery'

export function usePersistentQueryData<T>(response: Response<T>): T | undefined {
  const dataRef = React.useRef(response?.data)

  if (response.status === QueryStatus.SUCCESS) {
    dataRef.current = response.data
  }

  return dataRef.current
}
